import { z } from "zod";

/**
 * Kunden-Stammdaten pro Tenant.
 *
 * Liegt unter `.bidi-handel/tenants/<tenantId>/kunden.json`. Ersetzt das
 * Freitext-`kunde.name`-Feld in der Anfrage durch eine echte Referenz
 * (kundeId), damit Konditionen sauber an einer ID hängen koennen statt
 * an einem String-Fuzzy-Match.
 *
 * Pflichtfelder bewusst klein: kundeNummer + name reichen fuer den
 * Innendienst. Adresse + Kategorie + Bemerkung sind optional und werden
 * bei Bedarf nachgepflegt.
 *
 * Kategorie ist Freitext aus dem Repertoire ("Bautraeger", "Architekt",
 * "Eigenheim", "Bauunternehmen", "Handwerker", ...) — bewusst keine Enum,
 * weil sich das pro Pilot unterscheidet.
 */

export const KundenAdresseSchema = z
  .object({
    strasse: z.string().optional(),
    plz: z.string().optional(),
    ort: z.string().optional(),
    land: z.string().optional(),
  })
  .partial();
export type KundenAdresse = z.infer<typeof KundenAdresseSchema>;

export const KundeSchema = z.object({
  /** ULID oder vom ERP abgeleiteter String — global eindeutig pro Tenant. */
  id: z.string().min(1),
  /** Kundenummer aus dem ERP-System des Pilot-Haendlers. */
  kundeNummer: z.string().min(1),
  name: z.string().min(1),
  adresse: KundenAdresseSchema.optional(),
  /** Freitext-Kategorie: "Bautraeger", "Architekt", "Eigenheim", ... */
  kategorie: z.string().optional(),
  bemerkung: z.string().optional(),
  /** false = inaktiv, wird im Picker normalerweise ausgeblendet. */
  active: z.boolean().default(true),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});
export type Kunde = z.infer<typeof KundeSchema>;

export const KundenListeSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  kunden: z.array(KundeSchema).default([]),
});
export type KundenListe = z.infer<typeof KundenListeSchema>;
